import { call, put } from 'redux-saga/effects';

import { fetchFacebookCustomAudience } from 'api/WorkflowsAPI';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { FbCustomAudienceByAccountId } from 'modules/workflows/types';
import { getErrorResponse } from 'utils/xhr';
import { actions } from '../actions';

export default function* fetchFbCustomAudienceSaga() {
  try {
    const response: FbCustomAudienceByAccountId = yield call(fetchFacebookCustomAudience);
    yield put(actions.fetchFbCustomAudienceResponse(response));
  } catch (error) {
    const err = getErrorResponse(error);
    yield put(actions.fetchFbCustomAudienceError(err));
    const message = `Error fetching Facebook custom audiences. Please try again later.`;
    yield put(addNegativeToastWithErrorId(message, 'fetchFbCustomAudienceSaga'));
  }
}
